import { SATELLITE_ALL } from '../context/SatelliteContext';

/** Value for ?satellite= from global nav filter (ALL → omit). */
export function getSatelliteApiParam(contextSatellite) {
  const s = contextSatellite;
  if (!s || s === SATELLITE_ALL) return null;
  return String(s);
}

export function appendSatelliteToSearchParams(params, contextSatellite) {
  const v = getSatelliteApiParam(contextSatellite);
  if (v) params.append('satellite', v);
  return params;
}

/** Add or remove `satellite` on relative or absolute list/pagination URLs. */
export function applySatelliteQueryToUrl(url, contextSatellite) {
  const v = getSatelliteApiParam(contextSatellite);
  if (!url) return url;
  let u;
  try {
    u = /^https?:\/\//i.test(url)
      ? new URL(url)
      : new URL(url, 'http://api.local');
  } catch {
    return url;
  }
  if (v) u.searchParams.set('satellite', v);
  else u.searchParams.delete('satellite');
  return /^https?:\/\//i.test(url) ? u.toString() : u.pathname + u.search;
}

/** JSON body: empty string → null; omit undefined. */
export function satellitePayloadValue(value) {
  if (value == null) return null;
  const t = String(value).trim();
  return t === '' ? null : t;
}

/** UI table cell; CSV export uses N/A. */
export function displaySatellite(value, { csv = false } = {}) {
  if (value == null || String(value).trim() === '') return csv ? 'N/A' : '—';
  return String(value);
}
